import { useAuth } from '@/features/auth/AuthContext';

/**
 * SaaS gating for task-creation controls. `gated` is true on the SaaS
 * deployment (only classification / non-agentic tasks are self-serve);
 * `contactUs` is the modal opener whenever gated, so the "Contact us" link is
 * always offered on SaaS (the modal reports a filing failure itself if the
 * backend is not configured). Off SaaS both are inert.
 */
export default function useSaasGating(onContactUs) {
    const auth = useAuth();
    const gated = auth?.isSaas === true;
    const contactUs = gated ? onContactUs : undefined;
    return { gated, contactUs };
}
